import React from 'react'
import { Box, Center, Grid, Skeleton } from '@lojinha/design-system'
import styled from 'styled-components'

const Container = styled(Box)(
  ({ theme }) => `
    margin-top: -${theme.space.x64};

    ${theme.media.below('sm')} {
      margin-top: -${theme.space.x32};
    }
  `
)

export const Loading = () => {
  return (
    <Center htmlAttrs={{ style: { width: '100%' } }}>
      <Box height={['212px', '248px']}>
        <Skeleton />
      </Box>
      <Grid gridTemplateColumns={['repeat(12, 1fr)']}>
        <Grid gridColumn={['2 / 12', '2 / 12', '2 / 7']}>
          <Container height={['504px', '600px']}>
            <Skeleton htmlAttrs={{ style: { borderRadius: '8px' } }} />
          </Container>
        </Grid>
        <Grid gridColumn={['2 / 12', '2 / 12', '7 / 12']}>
          <Container height={['504px', '600px']}>
            <Skeleton htmlAttrs={{ style: { borderRadius: '8px' } }} />
          </Container>
        </Grid>
      </Grid>
    </Center>
  )
}
